import { PARTNER360_NAMESPACE } from 'legacy/lut/features/partner360/common/constants'

export const PARTNER360_FIN_SOB_SIDE_PANEL_NAMESPACE = `${PARTNER360_NAMESPACE}/finSobSidePpanel`

// Async thunk constants
export const REQUEST_FIN_SOB_SIDE_PANEL_SETTINGS = `${PARTNER360_FIN_SOB_SIDE_PANEL_NAMESPACE}/requestSettings`
export const REQUEST_COMPLETENESS_STATUS_FOR_FIN_SOB_SIDE_PANEL_ITEM = `${PARTNER360_FIN_SOB_SIDE_PANEL_NAMESPACE}/requestCompletenessStatusForFinSobSidePanelItem`
